import { useTimeZoneConverter } from "@/Hooks"
import { Dropdown, Icon, Label, Message } from "semantic-ui-react"
import BifrostModal from "../../../BifrostPageComponent/BifrostModal/BifrostModal"
import BifrostConfirmModalActions from "../../../BifrostPageComponent/BifrostModal/BifrostModalActions/BifrostConfirmModalActions"
import Loader from "../../../BifrostPageComponent/Loader/Loader"
import { useRemoveSubnetMappingModal } from "./hooks"

const RemoveSubnetMappingModal = ({ index, item, refresh }) => {
	const { state, openRemoveSubnetMappingModal, closeRemoveSubnetMappingModal, setMouseHover, confirmRemoveSubnetMapping, errorHandler } = useRemoveSubnetMappingModal(refresh, item)
	const { convertToBrowserTimeZone } = useTimeZoneConverter()

	return (
		<BifrostModal
			title={"Remove Subnet Mapping"}
			open={state.removeSubnetMappingModal}
			setOpen={openRemoveSubnetMappingModal}
			modalPage={
				<>
					{state.isLoading ? (
						<Loader backgroundColor="white" inverted height="1px" minHeight="20px" />
					) : state.isError ? (
						<Message negative>{state.errorMessage}</Message>
					) : (
						<Message warning style={{ color: "black" }}>
							Are you sure you want to remove {item.name && item.name + "'s"} access
							{item.mode === "" || item.mode === "Permanent" ? (
								""
							) : (
								<>
									<br />
									from
									<Label>{convertToBrowserTimeZone(item.activation)}</Label>
									to
									<Label>{convertToBrowserTimeZone(item.deactivation)}</Label>
								</>
							)}
							<br />
							at <strong>{item.subnet}</strong>?
						</Message>
					)}
				</>
			}
			trigger={
				<Dropdown.Item>
					<Icon
						link
						data-testid="subnet-mapping-delete"
						name="minus"
						size="small"
						circular={true}
						onMouseEnter={() => setMouseHover(index)}
						onMouseLeave={() => setMouseHover(-1)}
						style={{
							color: "darkred",
							backgroundColor: state.mouseHover === index ? "lightgrey" : null
						}}
					/>
					<span>Remove</span>
				</Dropdown.Item>
			}
			modalActions={
				<BifrostConfirmModalActions
					isError={state.isError}
					errorHandler={() => errorHandler()}
					loading={state.isLoading}
					confirmButtonColor="red"
					confirmText="Remove"
					confirmHandler={() => confirmRemoveSubnetMapping()}
					cancelHandler={() => closeRemoveSubnetMappingModal()}
				/>
			}
		/>
	)
}

export default RemoveSubnetMappingModal
